import {yupResolver} from '@hookform/resolvers/yup'
import {enqueueSnackbar} from 'notistack'
import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useForm} from 'react-hook-form'
import * as Yup from 'yup'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {KTableLoading} from '../../../../../../components/UI'
import {Select} from '../../../../../../components/UI/Select'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {SelectOption} from '../../../../../../models/utility.model'
import {useBooking} from '../../../../hooks/useBooking'
import {BookingNoteModel} from '../../../../models/booking.model'
import {
  createBookingNotesService,
  editBookingNotesService,
} from '../../../../services/booking.service'
import {getSnackBarToast} from '../../../../../../util/snackBar'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  noteToEdit: BookingNoteModel
  getNotes: () => void
  created: boolean
}

const ModalEditNote: FC<Props> = ({show, setShow, noteToEdit, getNotes, created}) => {
  const handleClose = () => {
    setShow(false)
    resetForm()
  }
  const {getTypeBookingNotes} = useBooking()
  const [loading] = useState(false)
  const [typeNotes, setTypeNotes] = useState<SelectOption[]>([])
  const {currentTabItem} = useHoteleria()

  const noteSchema = Yup.object().shape({
    TipoNotaId: Yup.string().required('Tipo de Nota es requerido'),
    Nota: Yup.string().required('Nota es requerido'),
  })

  const getSnackBar = (message: string, variant: boolean) => {
    enqueueSnackbar(message, {
      variant: variant ? 'success' : 'error',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
      },
    })
  }

  const {
    register,
    setValue,
    handleSubmit,
    // setError,
    // watch,
    control,
    formState: {errors},
  } = useForm<BookingNoteModel>({
    resolver: yupResolver(noteSchema),
  })

  const resetForm = () => {
    setValue('TipoNotaId', '')
    setValue('Nota', '')
  }

  const getTypeBookingNotesFn = async () => {
    const data = await getTypeBookingNotes()
    setTypeNotes(data)
  }

  useEffect(() => {
    getTypeBookingNotesFn()
    setValue('ReservaId', currentTabItem.idToEdit as any)
  }, [])

  useEffect(() => {
    if (!created) {
      // const {TipoNotaId, Nota, Id} = noteToEdit
      setValue('Id', noteToEdit?.Id)
      setValue('TipoNotaId', noteToEdit?.TipoNotaId)
      setValue('Nota', noteToEdit?.Nota)
    }
  }, [created])

  const onSubmit = async (data: BookingNoteModel) => {
    try {
      const {data: res} = created
        ? await createBookingNotesService(data)
        : await editBookingNotesService(data)
      if (!res.error) {
        getSnackBarToast(`Se ${created ? 'creó' : 'actualizó'} con exito`, 'success')
        handleClose()
        getNotes()
        // mostrar snackbar
      } else {
        getSnackBarToast(res.message || 'Hubo un error', 'error')
      }
    } catch (error) {
      getSnackBarToast('Hubo un error', 'error')
    }
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-xl'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>{created ? 'Crear' : 'Editar'} Nota</h5>

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <form>
            <div className='p-6'>
              <div className='d-flex'>
                <div className='col-6'>
                  <div className='mb-2 col-sm-12 col-lg-12'>
                    <label className='required'>Tipo de Nota:</label>
                    <Select control={control} name='TipoNotaId' data={typeNotes} errors={errors} />
                  </div>
                </div>
                <div className='col-6'>
                  <div className='mb-2 col-12'>
                    <label className='required form-label'>Nota</label>
                    <div
                      className='input-group input-group-sm'
                      style={{
                        width: '97%',
                      }}
                    >
                      <textarea className='form-control w-95' {...register('Nota')} />
                    </div>
                    <p
                      style={{
                        marginBottom: '0',
                        fontSize: '10px',
                        fontWeight: '600',
                        color: 'red',
                        marginLeft: '5px',
                      }}
                    >
                      {errors.Nota?.message}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
            <div className='d-flex justify-content-center mb-3'>
              <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                Cancelar
              </button>
              <button type='button' className='btn btn-primary' onClick={handleSubmit(onSubmit)}>
                Guardar
              </button>
            </div>
          </form>
          {loading ? <KTableLoading title='Cargando...' /> : null}
        </div>
      </div>
      {/* <SnackbarProvider /> */}
    </Modal>
  )
}

export {ModalEditNote}
